var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"isDeleted",class:_vm.statusColor},[_vm._v(" "+_vm._s(_vm.rowData.isDeleted ? _vm.$t('developer-tab.shared.deleted') : _vm.$t('developer-tab.shared.active'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }